"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullName = exports.isManager = exports.isTeamAdmin = exports.isCompanyOrSupportAdmin = exports.isSupportAdmin = exports.isCompanyAdmin = void 0;
const lodash_1 = __importDefault(require("lodash"));
const isCompanyAdmin = (roles) => !!roles.some(role => role.roleId === 'company_admin');
exports.isCompanyAdmin = isCompanyAdmin;
const isSupportAdmin = (roles) => !!roles.some(role => role.roleId === 'tradeshift_support_admin');
exports.isSupportAdmin = isSupportAdmin;
const isCompanyOrSupportAdmin = (roles) => (0, exports.isCompanyAdmin)(roles) || (0, exports.isSupportAdmin)(roles);
exports.isCompanyOrSupportAdmin = isCompanyOrSupportAdmin;
const isTeamAdmin = (roles) => !!roles.some(role => role.roleId === 'team_admin');
exports.isTeamAdmin = isTeamAdmin;
const isManager = (roles) => !!roles.some(role => role.roleId === 'manager');
exports.isManager = isManager;
const fullName = (user) => {
    user = user || {};
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    if (!firstName && !lastName) {
        return lodash_1.default.escape(user.email);
    }
    let fullName = firstName + ' ';
    fullName = fullName + lastName;
    return lodash_1.default.escape(fullName);
};
exports.fullName = fullName;
